const tour = {
  getStarted: "Empieza a usar <strong>MERU</strong>!",
  hereYouWillFind:
    "Aquí encontrarás una lista de todos los equipos pertenecientes a la empresa.",
  smartSearch: "Motor de búsqueda inteligente",
  ifYouWantToSearch:
    "Si quieres buscar un equipo específico por su código, puedes usar nuestro motor de búsqueda inteligente.",
  youCanExpandARow: "Al expandir una fila, entontrarás más opciones",
  options:
    "Las opciones dispnibles son Crear una Nueva Inspección, Reporte de Confiabilidad o simplemente ver el <strong>TABLERO</strong> de este equipo.",
  goingToTheDashboard: "Ir al Tablero",
  youCanAlsoUse:
    "Puedes ir al tablero de este equipo, solo inténtalo, haz clic en la fila",
  navigationDrawerTitle: "Barra de Navegación (&#9776;)",
  navigationDrawerContent:
    "Esta es la barra de navegación, aquí puedes ir a otras rutas importantes dentro de la aplicación, como tu perfil de usuario o reportar un error, incluso escanear un Código QR para hacer una nueva inspección o reporte de confiabilidad."
};
export default tour;
